import React, { useEffect, useState } from 'react'
import axios from 'axios'
import Modal from '../shared/modal'
import { t } from '../../i18n'
import { CopySourceServoMoveStep, MoveStepType } from './models'

interface Props {
  moveStepType: MoveStepType
  currentServoMoveStepId: number | null
  onSelect: (source: CopySourceServoMoveStep) => void
  onClose: () => void
}

const scope = 'servo_move_steps.copy_from_step'

const CopyFromServoMoveStepModal = ({
  moveStepType,
  currentServoMoveStepId,
  onSelect,
  onClose
}: Props) => {
  const [sources, setSources] = useState<CopySourceServoMoveStep[] | null>(null)
  const [loadError, setLoadError] = useState(false)
  const [searchQuery, setSearchQuery] = useState('')

  useEffect(() => {
    axios
      .get<CopySourceServoMoveStep[]>('/admin/servo_move_steps/copy_sources', {
        params: {
          move_step_type: moveStepType,
          exclude_servo_move_step_id: currentServoMoveStepId
        }
      })
      .then((resp) => setSources(resp.data))
      .catch(() => setLoadError(true))
  }, [moveStepType, currentServoMoveStepId])

  const query = searchQuery.trim().toLowerCase()
  const visibleSources = (sources ?? []).filter((source) =>
    (source.name ?? '').toLowerCase().includes(query)
  )

  return (
    <Modal headerText={t('title', { scope })} widen onClose={onClose}>
      <div className="form-group mb-3">
        <input
          className="form-control"
          placeholder={t('search_placeholder', { scope })}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      {loadError && <p className="text-danger">{t('load_error', { scope })}</p>}
      {!loadError && sources === null && (
        <p className="text-secondary">{t('loading', { scope })}</p>
      )}
      {sources !== null && visibleSources.length === 0 && (
        <p className="text-secondary">{t('no_steps', { scope })}</p>
      )}

      {visibleSources.length > 0 && (
        <div style={{ maxHeight: '50vh', overflowY: 'auto' }}>
          {visibleSources.map((source) => (
            <button
              key={source.id}
              type="button"
              className="btn btn-light w-100 text-start mb-2 d-flex align-items-center justify-content-between"
              onClick={() => onSelect(source)}
            >
              <span>
                {source.name}{' '}
                <span className="text-secondary">v{source.version_number}</span>
              </span>
              <span className="text-secondary">
                {t('moves', { scope, count: source.servo_moves.length })}
                {source.comments_count > 0 &&
                  ` · ★ ${source.average_rating} (${source.comments_count})`}
              </span>
            </button>
          ))}
        </div>
      )}

      <div className="buttons mt-3 d-flex justify-content-end">
        <button type="button" className="btn btn-secondary" onClick={onClose}>
          {t('cancel')}
        </button>
      </div>
    </Modal>
  )
}

export default CopyFromServoMoveStepModal
